import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { CopyLinkClicked, TwitterButtonAnalytics } from '../../../utils/Analytics.js';
import SocialButton from './SocialButton.jsx';

const url = window.location.href;

class CopyButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };

        this.url = this.props.profileUrl
    }

    render() {
        const color = this.props.color;
        return (
            <SocialButton
                imageSrc='https://cdn.obsess-vr.com/ferragamo/icon-link_.svg'
                style={this.props.style}
                redirectUrl={this.url}
                color={color}
                onClickAnalytics={CopyLinkClicked}
                copyLink={true}
            />
        );
    }
}

CopyButton.propTypes = {
    style: PropTypes.object
};

export default CopyButton;
